module.exports = __webpack_public_path__ + "img/rwanda.542d6d5b.png";